module.exports = __webpack_public_path__ + "img/menu_btn.c5877e26.png";